import React, { Component } from "react";
import PaginaToolbar from "../../components/PaginaToolbar";
import { criarGrupoRecursoDs } from "../../DataSources";
import {
  DataGrid,
  StateStoring,
  FilterRow,
  Editing,
  Column,
  Paging,
  Pager
} from "devextreme-react/data-grid";
import uiInfo from "../../ui-info";
import memoria from "../../Memoria";
import { Lookup } from "devextreme-react/filter-builder";
import UserInfo from "../../UserInfo";
import notify from "devextreme/ui/notify";

export default class GrupoRecursoBox extends Component {
  constructor(props) {
    super(props);
    this._gridInstance = React.createRef();
    this.grupoRecursoDs = criarGrupoRecursoDs();
    this.onSelecionado = props.onSelecionado;
    this.usadoComoPesquisa = props.onSelecionado !== undefined;
    this.onAtualizandoRow = this.onAtualizandoRow.bind(this);
    this.gestorDataSource = [
      { id: "1", descricao: "PREFEITURA" },
      { id: "2", descricao: "TRIMAP" },
    ];
  }

  onAtualizandoRow(e) {
    e.cancel = true;
    console.log("evento e", e);
    if (e.data.gestor == "2" && !UserInfo.gerenciaPrefeitura() && UserInfo.possuiSubPerfil("adm")) {
      notify("Acesso negado", "error");
      return;
    }
    this.props.history.push("gruporecurso/editar/" + e.data.id);
  }

  componentDidMount() {
    memoria.redirecionarSeNecessario(this.props.location, this.props.history);
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <PaginaToolbar
            titulo="Grupo de Recurso"
            novoCb={this.novoGrupoRecurso.bind(this)}
          >
            <DataGrid
              ref={(grid) => (this._gridInstance = grid)}
              dataSource={this.grupoRecursoDs}
              showBorders={true}
              rowAlternationEnabled={true}
              focusedRowEnabled={true}
              remoteOperations={true}
              columnAutoWidth={true}
              columnHidingEnabled={true}
              wordWrapEnabled={window.innerWidth < 800}
              filterSyncEnabled={true}
              onEditingStart={this.onAtualizandoRow}
            >
              <FilterRow visible={true} />
              <Editing
                allowDeleting={!this.usadoComoPesquisa}
                allowUpdating={!this.usadoComoPesquisa}
                useIcons={true}
                visible={!this.usadoComoPesquisa}
              />
              <Column
                type="buttons"
                fixed={true}
                fixedPosition={"left"}
                buttons={[
                  "edit",
                  "delete",
                  {
                    hint: "Selecionar",
                    icon: "repeat",
                    visible: this.usadoComoPesquisa,
                    onClick: this.onSelecionado,
                  },
                ]}
              />
              <Column dataField={"gestor"} width={150}>
                <Lookup dataSource={this.gestorDataSource} valueExpr={"id"} displayExpr={"descricao"} />
              </Column>
              <Column dataField={"nome"} />
              <Column dataField={"permissoes"} visible={false} />
              <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />

              <Pager
                showInfo={true}
                showNavigationButtons={true}
                showPageSizeSelector={true}
                allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
              />
            </DataGrid>
          </PaginaToolbar>
        </div>
      </React.Fragment>
    );
  }

  novoGrupoRecurso() {
    this.props.history.push("gruporecurso/novo");
  }
}
